{% block swag_migration_error_resolution_details_modal %}
    <sw-modal
        class="swag-migration-error-resolution-details-modal"
        variant="large"
        :title="modalTitle"
        @modal-close="() => $emit('modal-close')"
    >
        <div class="swag-migration-error-resolution-details-modal__container">
            {% block swag_migration_error_resolution_details_modal_converted_data_editor %}
                <sw-code-editor
                    v-if="convertedData"
                    class="swag-migration-error-resolution-details-modal__code-editor-converted-data"
                    name="migration-resolution-details-modal--code-editor"
                    :label="$tc('swag-migration.index.error-resolution.modals.details.convertedDataLabel')"
                    :value="convertedData"
                />
            {% endblock %}

            {% block swag_migration_error_resolution_details_modal_source_data_editor %}
                <sw-code-editor
                    v-if="sourceData"
                    class="swag-migration-error-resolution-details-modal__code-editor-source-data"
                    name="migration-resolution-details-modal--code-editor"
                    :label="$tc('swag-migration.index.error-resolution.modals.details.sourceDataLabel')"
                    :value="sourceData"
                />
            {% endblock %}
        </div>
    </sw-modal>
{% endblock %}
